export const TRANSLATIONS_EN = {
  accept: 'Accept',
  accepted: 'Accepted',
  acceptedBy: 'Accepted by:',
  acceptedDateOverview: 'Accepted date: ',
  acceptedService: 'Acceptation {{dictionary.commonTerms.service}}',
  account: 'account',
  accountAddress: 'Account address',
  accountHasNotSendTestSetDian: 'Your account has not yet submitted the test set for authorization by the DIAN',
  accountLogo: 'Account logo',
  accountName: 'Account name',
  accountType: 'Account Type',
  accounts: 'Accounts',
  action: 'Action',
  actions: 'Actions',
  activateExtendForm: 'enable extended form',
  activated: 'Activated',
  add: 'Add',
  addBlockedDays: 'Add blocked days',
  addItem: 'Add Item',
  addListItem: 'Add list item',
  addNote: 'Add note',
  addNotesDescription: 'Allow adding {{dictionary.commonTerms.notePlural}}',
  addPatientList: 'Add {{dictionary.commonTerms.finalCustomer}} to the list',
  addService: 'Add',
  addVariable: '+Add',
  additionalInformation: 'Aditional information',
  additionalPhones: 'Additional phones',
  address: 'Address',
  addressIsRequired: 'Address is required',
  addressPlaceholder: 'Enter an address',
  addressRequired: 'Address is required',
  adjustment: 'Adjustment',
  adjustmentNotes: 'Adjustment notes',
  admin: '{{dictionary.profileNames.admin}}',
  administrateAdvancedAvailability:
    'Can view and modify advanced availability of {{dictionary.profileNames.technicianPlural}}',
  administrateServices: 'Allows assigning {{dictionary.commonTerms.servicePlural}}',
  administration: 'Administration',
  advancedAvailability: 'Advanced availability',
  age: 'Age',
  alertResolvedBy: 'Alert resolved by: ',
  alertResolvedDate: 'Alert resolved date: ',
  allPatients: 'All {{dictionary.commonTerms.finalCustomerPlural}}',
  allowAssignServicesTo: 'Allow assign services to',
  allowCreation: 'You will create this {{dictionary.commonTerms.service}} without having assigned any specialist',
  allowFinalCustomerAssets:
    'Allow linking {{dictionary.commonTerms.assetPlural}} of {{dictionary.commonTerms.finalCustomer}}',
  allowFinalCustormerService:
    'Allow this {{dictionary.commonTerms.service}} type to have an associated {{dictionary.commonTerms.finalCustomer}}',
  allowToSubmitServiceTags: 'Allow to submit {{dictionary.commonTerms.service}} tags',
  allowToViewAllUsersHistory: 'allow to view all users History',
  allowToViewHistory: 'allow to view history',
  allowedIncidetnTypes: 'Types of {{dictionary.commonTerms.servicePlural}} allowed',
  amountPaid: 'Ammount Paid',
  amountRequired: 'Amount required',
  annulled: 'Anulled',
  answerCreate: 'Create answer',
  answerEdit: 'Edit answer',
  answers: 'Answers',
  answersFrequent: 'Frequent Answers',
  api: 'Api',
  apiAdminOptions: 'API (management options)',
  apiCreate: '+ Create new Api key',
  apiMessage: 'This is your Api key, Remember that it expires on',
  apiMessageWhatsapp: 'This is your code or key. Use this to place it in the Meta configuration',
  appColorMobile: 'Mobile app colors',
  appColorText: 'Select a color scheme, these colors will be used for some sections or buttons of the mobile app.',
  appMobileOptions: 'Mobile app configuration options',
  appMovilColor: 'App mobile colors',
  appPlaceholder: 'Select a {{dictionary.commonTerms.service}} form',
  apply: 'Apply',
  appoinmentNoAvailable:
    'There is not available {{dictionary.commonTerms.servicePlural}} for this search criteria, please select other options and try again.',
  appointment: 'Appointments',
  appointmentAssignation: '{{dictionary.commonTerms.service}} assignment',
  appointmentAssignmentMessage:
    'You are trying to assign the following {{dictionary.commonTerms.servicePlural}} to the {{dictionary.commonTerms.finalCustomer}}',
  appointmentAvailable: 'Appointment available',
  appointmentCancelation: '{{dictionary.commonTerms.service}} cancelation',
  appointmentModified: '{{dictionary.commonTerms.service}} modification',
  appointmentNotification:
    'I would like to receive notifications in case my appointment can be brought forward and I authorize them to contact me at my cell phone number',
  appointmentOpportunitiesReport: '{{dictionary.commonTerms.servicePlural}} opportunity report',
  appointmentRepeat: 'Repeat this{{dictionary.commonTerms.service}}',
  appointmentScheduledSuccessfully: 'Your appointment has been scheduled successfully',
  appointmentScheduledToDate: 'To {{date}} at {{time}}',
  appointmentsOf: 'Appointments of',
  areYouSure: 'Are you sure?',
  asset: '{{dictionary.commonTerms.asset}}',
  assetActive: 'Active',
  assetHasOverlaps: '{{dictionary.commonTerms.asset}} has a {{dictionary.commonTerms.service}} at the same time',
  assetInactive: 'Inactive',
  assetInformation: '{{dictionary.commonTerms.asset}} information',
  assetNotAvailable: '{{dictionary.commonTerms.asset}} not available at this time',
  assetPlaceholder: 'Select {{dictionary.commonTerms.asset}}',
  assetReference: 'Id or Ref',
  assetReferenceAlreadyExists: 'The Id or Reference already exists',
  assetRequired: 'It is required to assign an Asset when assigning Appointments',
  assetTypes: '{{dictionary.commonTerms.assetPlural}} types',
  assets: '{{dictionary.commonTerms.assetPlural}}',
  assetsDescription:
    'Create a list of {{dictionary.commonTerms.assetPlural}} that work like databases and can be used at forms, create {{dictionary.commonTerms.service}}, etc.',
  assetsGeolocalization: 'Geolocalization of {{dictionary.commonTerms.assetPlural}}',
  assetsGeolocalizationDescription:
    'Displays the location of {{dictionary.commonTerms.assetPlural}} groups and their proximity to a key point',
  assetsGroup: 'Select the group of Assets that corresponds to this type of Appointment',
  assetsList: '{{dictionary.commonTerms.assetPlural}} list',
  assigmentAppoinment: 'Appointment scheduling for',
  assign: 'Assigned',
  assignIncidentOffSchedule: 'Assign {{dictionary.commonTerms.service}} outside of the schedule',
  assignationFinalCustomer: 'Assign {{dictionary.commonTerms.finalCustomerPlural}}',
  assignedCompany: 'Company',
  assignedDate: 'Assigned date',
  assignedDateOverview: 'Asignation Date: ',
  assignedService: 'Assignation of {{dictionary.commonTerms.service}}',
  assignedTo: 'Assigned To: ',
  assignments: 'assignments',
  atLeastOneDateRangeMustBeSelected: 'Must select at least 1 date range',
  attachFiles: 'Attach files',
  attachPDF: 'Attach PDF:',
  attachmentWillBeRemoved: 'The attachment: "{{filename}}" will be removed',
  attachments: 'Attachments',
  audio: 'Audio',
  automaticInvoiceSend: 'Automatic invoice sending',
  automaticNotification: 'Automatic notification',
  automaticSend: 'Automatic sending',
  availability: 'Configure Availability',
  availabilityDesccription:
    'Configure the availability of your Resources under multiple parameters, like headquarter or type of {{dictionary.commonTerms.service}}',
  availabilityTitle: 'Availability',
  available: 'Available',
  awaitingList: 'Awaiting List',
  awaitingListDescription:
    'Create a list with {{dictionary.commonTerms.finalCustomerPlural}} who have been waiting for {{dictionary.commonTerms.servicePlural}} assignment or advance current assignments.',
  backToHome: 'Back to home',
  bannerSizeXY: 'Banner (Size {{x}} by {{y}})',
  barcode: 'Barcoode',
  basePrice: 'Base price',
  basename: 'basename',
  basenamePlaceholder: 'enter basename',
  billableServices: 'Billable {{dictionary.commonTerms.servicePlural}}',
  billed: 'Billed',
  billing: 'Billing',
  billingCompanyDuplicated: 'Billing company already exists',
  billingConfiguration: 'Billing configuration',
  billingCreditNoteRejectedByDian: 'The credit note has been rejected by the DIAN',
  billingCustomers: 'Billing customers',
  billingDescription:
    'Perform electronic invoicing for your {{dictionary.commonTerms.servicePlural}} and generate the associated documents',
  billingInvoiceCommunicationError: 'An error occurred while communicating with the DIAN.',
  billingInvoiceRejectedByDian: 'The invoice has been rejected by the DIAN',
  billingServices: 'Billing {{dictionary.commonTerms.servicePlural}}',
  biologicalSex: 'Biological Sex',
  biologicalSexPlaceholder: 'Select a biological sex',
  biologicalSexRequired: 'Biological sex is required',
  birthDate: 'Birthdate',
  birthdatePlaceholder: 'Enter a birthdate',
  birthdateRequired: 'Birthdate is required',
  blackTheme: 'Black',
  blockDays: 'Block specific days',
  blockDaysdescription: 'You can add blocks in the scheduling for specific days and hours',
  blockSchedule: 'Block schedule',
  blockedDays: 'Blocked Days',
  bloodType: 'Blood type',
  bloodTypePlaceholder: 'Select a blood type',
  bloodTypeRequired: 'Blood type is required',
  blueTheme: 'Blue',
  boardFields: 'Board fields',
  calendar: 'Calendar',
  calendarFilters: 'Filter calendar',
  canCreateIncidentNotes: 'Can add {{dictionary.commonTerms.notePlural}}',
  canCreateServices: 'Can create {{dictionary.commonTerms.servicePlural}}',
  canEditAssets: 'Can edit {{dictionary.commonTerms.assetPlural}}',
  canEditCustomers: 'Can edit {{dictionary.commonTerms.customer}}',
  canEditFinalCustomers: 'Can edit {{dictionary.commonTerms.finalCustomerPlural}}',
  canEditReviewForm: 'Can edit {{dictionary.commonTerms.review}} form',
  canEditServicesSummary:
    'Can view edit icons of the {{dictionary.commonTerms.summary}} of {{dictionary.commonTerms.service}}',
  canViewAndCreateAdjustmentNotes: 'Can view and create adjustment notes',
  canViewAndCreateBilling: 'Can view and create billing',
  canViewAndCreateCreditNotes: 'Can view and create credit notes',
  canViewAssets: 'Can view {{dictionary.commonTerms.assetPlural}}',
  canViewCustomers: 'Can view {{dictionary.commonTerms.customer}}',
  canViewFinalCustomers: 'Can view {{dictionary.commonTerms.finalCustomerPlural}}',
  canViewIncidentNotes: 'Can view {{dictionary.commonTerms.notePlural}}',
  canViewResourceTracking: 'Can view {{dictionary.profileNames.technicianPlural}} tracking view',
  canViewReviewForm: 'Can view {{dictionary.commonTerms.review}} form',
  canViewServicesSummary: 'Can view {{dictionary.commonTerms.summary}} of {{dictionary.commonTerms.service}}',
  cancel: 'Cancel',
  cancelAvailability: 'You are trying to cancel the availability of',
  cancelSequenceStep: 'Cancel step',
  cancelationDate: 'Cancelation date: ',
  canceled: 'Canceled',
  canceledService: 'Cancelation {{dictionary.commonTerms.service}}',
  canceledStep: 'canceled step',
  cancelingAvailabilityOf: 'You are trying to cancel the availability of',
  cancelingAvailabilityOfCalendar: 'are trying to cancel {{dictionary.commonTerms.servicePlural}} of',
  cancellationDate: 'Date',
  cancellationReasson: 'Cancellation reasson',
  cancellationReassons: 'Cancellation reassons',
  cancelledBy: 'cancelled By: ',
  cancelledService: 'Allow offering {{dictionary.commonTerms.servicePlural}} after cancellation',
  cantBeEmpty: "Can't be empty",
  cantHaveSpaces: "Can't have spaces",
  cantSaveRecord: "Can't save record",
  changesWillNotBeSaved: 'Changes will not be saved',
  characterText: 'of {{n}} characters',
  chat: 'Chat',
  chatActive: 'Active chat',
  chatCancelled: 'Chat Cancelled',
  chatCancelledTag: 'Cancelled',
  chatClosedTag: 'Closed',
  chatFinishConfirmMessage: 'The chat will be finished and no new mesages can be sent',
  chatFinished: 'Finished chat',
  chatOpenTag: 'Active',
  chatRejectedTag: 'Rejected',
  chatUnassignedTag: 'Unassigned',
  chatWaitForFinalCustomerResponseTag: 'Waiting for response',
  checkStatusPayment: 'Check status',
  cityPlaceholder: 'Select residence city',
  clear: 'Clear',
  clickOrDragToUpload: 'Click or drag to this area to upload a file',
  clientType: 'Client type',
  codeReference: 'Code or reference',
  collaborators: 'Collaborators',
  color: 'Color',
  colorApplication: 'Aplication Color',
  colorMark: 'Color Marking',
  colorPlaceholder: 'Enter Color',
  colorRequired: 'You need to select a color.',
  comment: 'Comment',
  commentInvoiceItem: 'Comment on invoice item',
  compactView: 'Compact view',
  companion: 'Guardian/Companion/Responsible',
  company: '{{dictionary.commonTerms.customer}}',
  companyAddress: '{{dictionary.commonTerms.customer}} address',
  companyName: 'Company Name',
  completeMFService: 'Completed the Mobile Form',
  completeName: 'Full Name',
  completeRFService: 'Completed the Review Form',
  completedFormMobileBy: '{{dictionary.commonTerms.service}} form completed by: ',
  completedFormMobileDate: 'Form completed date: ',
  completedFormReviewBy: 'Form completed by: ',
  completedFormReviewDate: 'Form completed date: ',
  concept: 'Concept',
  conceptPlaceholder: 'Select a concept',
  conditionalValueRequired: 'Missing required conditional value',
  config: 'Config',
  configAppMobileOptions: 'App mobile options configuration ',
  configTemplates: 'Configure templates',
  configUserMessage: 'Select the type of user, enter the basic information and assign a password',
  configuration: 'Configuration',
  configured: 'Configured',
  confirm: 'Confirm',
  confirmPassword: 'confirm password',
  confirmation: 'Confirmation',
  confirmedByFinalCustomer: 'Confirmed by {{dictionary.commonTerms.finalCustomer}}',
  confirmedByFinalCustomerDate: 'Confirmed Date {{dictionary.commonTerms.finalCustomer}}: ',
  confirmedByUser: 'Confirmed',
  confirmedService: 'Confirmed {{dictionary.commonTerms.service}}',
  confirmedServiceDescription: 'The {{dictionary.commonTerms.service}} will be marked as confirmed',
  contact: '{{dictionary.commonTerms.contact}}',
  contactAddress: '{{dictionary.commonTerms.contact}} address',
  contactNumber: 'Contact number',
  contactPhone: '{{dictionary.commonTerms.contact}} phone',
  contactPlaceholder: 'Select {{dictionary.commonTerms.contact}}',
  contactReference: '{{dictionary.commonTerms.contact}} reference',
  contactRequired: '{{dictionary.commonTerms.contact}} is required',
  contacts: '{{dictionary.commonTerms.contactPlural}}',
  container: 'Container',
  continue: 'Continue',
  contractNumber: 'Contract number',
  contractPaymentMethod: 'Contract payment method',
  couldNotUploadFile: 'Could not upload file: {{filename}}',
  country: 'Country',
  countryPlaceholder: 'Select a country',
  countryRequired: 'must select a country',
  create: 'Create',
  createAccount: 'Create Account',
  createAppointment: 'Create {{dictionary.commonTerms.service}}',
  createAsset: 'Create {{dictionary.commonTerms.asset}}',
  createAssetType: 'Create {{dictionary.commonTerms.asset}} type',
  createAvailability: 'New Availability',
  createCancellationReasson: 'Create cancellation reasson',
  createContact: 'Create {{dictionary.commonTerms.contact}}',
  createCustomer: 'Create {{dictionary.commonTerms.customer}}',
  createCustomerTextOptions: 'Allow to create and modify {{dictionary.commonTerms.customerPlural}} from the mobile app',
  createDiary: 'Agenda Creation',
  createDictionary: 'Create Dictionary',
  createFinalCustomer: 'Create {{dictionary.commonTerms.finalCustomer}}',
  createFinalCustomerTag: 'Create Tags for {{dictionary.commonTerms.finalCustomer}}',
  createFinalCustomerTextOptions:
    'Allow to create and modify {{dictionary.commonTerms.finalCustomer}} from the mobile app',
  createHeadquarter: 'Create {{dictionary.commonTerms.headquarter}}',
  createHere: 'You can create in this link.',
  createKey: '+ Create new key',
  createList: 'Create List',
  createListNode: 'Create List Node',
  createMenu: 'Create Menu',
  createNode: 'Create Node',
  createNote: 'Create {{dictionary.commonTerms.note}}',
  createNotes: 'Create {{dictionary.commonTerms.notePlural}}',
  createNotesType: 'Create {{dictionary.commonTerms.note}} type',
  createNotification: 'Create notification',
  createSequence: 'Create Sequence',
  createService: 'Create {{dictionary.commonTerms.service}}',
  createServicesFromMobile: 'Create services from mobile',
  createServicesTextOptions: 'Allow to create {{dictionary.commonTerms.servicePlural}} from the mobile app',
  createSkill: 'Create skill',
  createSurvey: 'Create survey',
  createSurveyGroup: 'create Survey Group',
  createUser: 'Create user',
  created: 'Created!',
  createdBy: 'Creado By: ',
  createdRecords: 'Records created',
  createdService: 'Created {{dictionary.commonTerms.service}}',
  creationDate: 'Creation date',
  creationOfRequests: 'Creation of request',
  creationOfRequestsDescription:
    'If you enable this option, the interested user will be able to create a request for a {{dictionary.commonTerms.service}}, he will remain with the Requested status and will require an administrator or {{dictionary.profileNames.operator}} to assign a {{dictionary.profileNames.technician}} and define the {{dictionary.commonTerms.service}} Type',
  creationType: 'Creation Type',
  creationTypePlaceholder: 'Select Scheduling Type',
  creator: 'Creator',
  creditNote: 'Credit note',
  creditNoteTemplate: 'Credit note template',
  creditNotes: 'Credit notes',
  currencyRequired: 'Currency required',
  currentConsecutive: 'Current consecutive',
  currentValue: 'Current value',
  custom: 'Custom',
  customFieldPlaceholder: 'Enter {{label}}',
  customFooterImage:
    'Use a custom image to display in the page footer. The image size should be 782px x 80px (Width - Height)',
  customHeaderImage:
    'Use a custom image to display in the page header. The image size should be 782px x 80px (Width - Height)',
  customImageForReports:
    'Use a custom image to display in the reports. The image size should be 360px x 135px (Width - Height)',
  customList: 'Custom list',
  customListPlaceholder: 'Select custom list',
  customLists: 'Custom lists',
  customPDFImagesText: 'Standard PDF with different images',
  customPDFTemplateText: 'Fully Customized PDF',
  customPdfDescription:
    'If you enable this option, the PDFs generated from the information of the appointment types will appear according to the custom PDF configuration',
  customReportSettings: 'Report settings',
  customer: '{{dictionary.commonTerms.customer}}',
  customerLabel: 'Customer',
  customerLocation: '{{dictionary.commonTerms.customer}} location',
  customerName: '{{dictionary.commonTerms.customer}} Name',
  customerPhone: '{{dictionary.commonTerms.customer}} phone',
  customerPlaceholder: 'Select {{dictionary.commonTerms.customer}}',
  customerPlaceholderLabel: 'Select customer',
  customerRequired: '{{dictionary.commonTerms.customer}} is required',
  customers: '{{dictionary.commonTerms.customerPlural}}',
  customersDescription:
    ' If your institution management {{dictionary.commonTerms.customerPlural}} list, you can select the specific {{dictionary.commonTerms.customer}} to create the {{dictionary.commonTerms.service}}',
  customersLabel: 'Customers',
  customersToView: '{{dictionary.commonTerms.customerPlural}} to show',
  customizationAdminOptions: 'Customization (management options)',
  dashboard: 'Dashboard',
  dataPolicyMessage: 'Data policy',
  dataTreatment: 'Data treatment',
  date: 'Date',
  datesAvailablesNotFound: 'Didnt you find any available dates for the {{dictionary.commonTerms.service}} you need?',
  day: 'Day',
  days: 'Days',
  decimalError: 'Only accepted integer values',
  defaultPaymentTerm: 'Default payment term (days)',
  delete: 'Delete',
  deleteStatus: ' Delete',
  departamentPlaceholder: 'Select residence department',
  departmentPlaceholder: 'Select a residence department',
  description: 'description',
  descriptionErrorNotification: 'You already have a notification with this incorrect configuration',
  descriptionOrComment: ' Description or coment',
  descriptionPlaceholder: 'enter description',
  descriptionSelectServiceTypeClient:
    'Select the types of {{dictionary.commonTerms.service}} for this {{dictionary.commonTerms.customer}} ',
  descriptionSelfScheduling:
    'Enable a link to allow your {{dictionary.commonTerms.finalCustomerPlural}} to schedule {{dictionary.commonTerms.servicePlural}} on their own',
  destination: 'Destination',
  devices: 'Devices',
  dianAuthorization: 'DIAN authorization',
  dianAuthorizationDescription: 'Enter the corresponding information for the DIAN',
  dianRegistrationInformation: 'DIAN registration information',
  diary: 'Diary',
  dictionary: 'Dictionary',
  didUnassignIncident: 'Unassigned {{dictionary.commonTerms.service}}',
  didUpdateService: 'updated {{dictionary.commonTerms.service}}',
  digitalCertificate: 'Digital certificate',
  digitalSignatureIsUploaded: 'You have already uploaded your digital signature',
  disableAudio: 'Disable audio on start',
  disableLeaveButton: 'Disable leave button',
  disablePeopleList: 'Disable people list',
  disableVideo: 'Disable video on start',
  discount: 'Discount',
  displayOptions: 'Display options',
  displayReviewFormOnlyOnAlert: 'Display review form only in case of alert',
  distance: 'Distance',
  doctor: 'Doctor',
  documentNumberNotRegistered:
    'Sorry, your document id was not found in the system for this reason you cant schedule your {{dictionary.commonTerms.service}}. Please contact with the entityto resolve your request',
  documentType: 'Document type',
  documentTypePlaceholder: 'Select document type',
  documentTypeRequired: 'Document type is required',
  documents: 'Documents',
  download: 'Download',
  downloadBaseTemplate: 'Download base template to import lists',
  downloadFormat: 'Download format',
  downloadImportsTemplateFile: 'Download base template file for imports',
  downloadReport: 'Download report',
  downloadServiceFiles: 'Download files of {{dictionary.commonTerms.service}}',
  downloadTemplate: 'Download template',
  doyouAgree: 'Do you agree?',
  draft: 'Draft',
  duration: 'Duration',
  edit: 'Edit',
  editAccount: 'Edit account',
  editAvailability: 'Edit Availability',
  editCancellationReasson: 'Edit cancellation reasson',
  editContact: 'Edit {{dictionary.commonTerms.contact}}',
  editCustomer: 'Edit {{dictionary.commonTerms.customer}}',
  editDictionary: 'Edit Dictionary',
  editFinalCustomer: 'Edit {{dictionary.commonTerms.finalCustomer}}',
  editFinalCustomerTag: 'Edit Tag for {{dictionary.commonTerms.finalCustomer}}',
  editHeadquarter: 'Edit {{dictionary.commonTerms.headquarter}}',
  editIncidentType: 'Edit {{dictionary.commonTerms.service}} type',
  editInfoCustomers: 'Can modify information of {{dictionary.commonTerms.customerPlural}}',
  editMainPage: 'Edit main page',
  editMenu: 'Edit Menu',
  editNotesType: 'Edit note type',
  editNotification: 'Edit notification',
  editSequence: 'Edit Sequence',
  editService: 'Edit {{dictionary.commonTerms.service}}',
  editSkill: 'Edit skill',
  editState: 'Edit State',
  editSurvey: 'Edit Survey',
  editSurveyGroup: 'Edit Survey Group',
  editUser: 'Edit User',
  editVariable: 'Edit variable',
  email: 'Email address',
  emailAlreadyExists: 'email already exists',
  emailExample: 'hello@netuxtecnologia.com',
  emailMenu: 'Email',
  emailPlaceholder: 'Enter email address',
  emailRecipient: 'email recipiente receives the notification',
  emailRequired: 'Enter is required',
  emailsToSent: 'Email of the person who will receive the notification',
  emergency: 'Emergencies',
  emergencyContact: 'Emergency Contact:',
  emergencyWork: 'Field Care or',
  employee: 'Employee',
  employeePlural: 'Employees',
  enableAvailability: 'Enable Availability',
  enableChat: 'Enable chat',
  enableCustomPdf: 'Enable Custom PDF',
  enableExcelExportation: 'Enable exportation in excel button',
  enableForcedAvailabilityLocks: 'Enable to force the creation of availability locks',
  enableForm: 'Enable {{dictionary.commonTerms.review}} form.',
  enableGeolocalization: 'Enable geolocalization',
  enablePaymentGatewaysTitle: 'Enable payment gateways',
  enableRecording: 'Enable recording',
  enableScreenshare: 'Enable screenshare',
  enableSelfscheulding: 'Enable this availability for web self-scheduling',
  enableSendEmailButton: 'Enable send email button',
  enableServiceTypeForSelfScheduling: 'Enable {{dictionary.commonTerms.service}} type for self scheduling',
  enableServiceTypesClient:
    'Do you want to enable all types of {{dictionary.commonTerms.service}} for this {{dictionary.commonTerms.customer}}?',
  enableSupportChat: 'Enable support chat',
  enableToAssignIncidentsOutOfSchedule:
    'Enable assignment of {{dictionary.commonTerms.servicePlural}} outside of the schedule or with overlaps',
  enabledProductionEnviroment: 'Enabled production enviroment',
  enabledUsers: 'Enabled Users',
  enabling: 'Enabling',
  enablingCode: 'Enabling code',
  enablingCodeValidationPattern: 'Enabling code must be a number with 12 digits',
  endDate: 'End date',
  endHour: 'End hour',
  endpoint: 'Endpoint',
  endpointRequired: 'Endpoint required',
  english: 'English',
  enterDateList: 'List entry date',
  enterDatePlaceholder: 'Enter a date',
  enterNote: 'Enter {{dictionary.commonTerms.note}}',
  enterSession: 'Enter',
  enterSubject: 'Enter the email subject',
  enterYourData: 'Enter your data',
  enterprise: 'Empresa',
  enterpriseName: 'Company Name',
  enterprisePlaceholder: 'Netux S.A.S',
  entityName: 'Entity name',
  eps: 'Eps',
  error: 'Error',
  errorCancelingService: 'Error canceling {{dictionary.commonTerms.service}}',
  errorCreateMessage: 'An error occurred while creating message',
  errorCreatingRecord: 'There was an error creating the record',
  errorDeleteSkill: 'An error occurred while trying to delete the record',
  errorFinishingService: 'Error canceling {{dictionary.commonTerms.service}}',
  errorGeneratingReport: 'Error generating report',
  errorRecordAlreadyExists: 'Record already exists',
  errorRecordNotFound: 'Record not found',
  errorRemovingRecord: 'There was an error removing the record',
  errorRetrievingColors: 'There was an error retrieving colors',
  errorRetrievingGeolocation: "Couldn't retrieve geolocation info",
  errorRetrievingRecord: 'There was an error retrieving the record',
  errorRetrievingRecords: 'There was an error retrieving the records',
  errorSignDocument: 'There was an error saving the signature, please try again.',
  errorUpdatingRecord: 'There was an error updating the record',
  errorUploadingFile: 'There was an error uploading the file',
  errorValidateFile: 'There was an error uploading the preview file',
  executionDate: 'Execution date',
  executionTime: 'Execution time',
  expirationDate: 'Expiration date',
  export: 'Export',
  exportToPdf: 'Exportable to PDF',
  extendForm: 'With this web form you can extend the information required for the creation of a task',
  extendedExternalForm: 'Extended External Form',
  extendedExternalFormParagraph: 'With this web form you can extend the information required for self-scheulding',
  extension: '{{dictionary.commonTerms.extension}}',
  extensionLabel: 'Extension',
  extensionPlural: '{{dictionary.commonTerms.extensionPlural}}',
  field: 'Field',
  fieldIsRequired: 'This field is required',
  fieldName: 'Field name',
  fieldType: 'Field type',
  fields: 'Fields',
  file: 'file',
  fileMandatory: 'You must upload at least one file',
  fileMustBeImage: 'File must be an image (jpeg or png)',
  fileSizeExceeded: 'File size exceeded {{size}}MB',
  fileTypeNotSupported: 'File type not supported',
  files: 'Files',
  filesUploadingWillNotBeSaved: 'Files that are uploading will not be saved',
  filesWithErrorWillNotBeSaved: 'Files with error will not be saved',
  filterByServiceType: 'Filter by {{dictionary.commonTerms.service}} type',
  filterByTechnician: 'Filter by {{dictionary.profileNames.technician}}',
  filterServices: 'Filter {{dictionary.commonTerms.servicePlural}}',
  filters: 'Filters',
  finalCustomer: '{{dictionary.commonTerms.finalCustomer}}',
  finalCustomerAddress: '{{dictionary.commonTerms.finalCustomer}} address',
  finalCustomerAge: '{{dictionary.commonTerms.finalCustomer}}Age',
  finalCustomerCount: 'This {{dictionary.commonTerms.finalCustomer}} has had',
  finalCustomerCountText: '{{dictionary.commonTerms.servicePlural}}. Click the button to go the detail.',
  finalCustomerEmail: '{{dictionary.commonTerms.finalCustomer}} email',
  finalCustomerExpeditionDate: '{{dictionary.commonTerms.finalCustomer}} expedition date',
  finalCustomerIdentification: '{{dictionary.commonTerms.finalCustomer}} identification',
  finalCustomerIdentificationType: '{{dictionary.commonTerms.finalCustomer}} identification type',
  finalCustomerInfo: '{{dictionary.commonTerms.finalCustomer}} info',
  finalCustomerMobileNumber: '{{dictionary.commonTerms.finalCustomer}} mobile number',
  finalCustomerName: '{{dictionary.commonTerms.finalCustomer}} name',
  finalCustomerPhone: '{{dictionary.commonTerms.finalCustomer}} phone',
  finalCustomerPlaceholder: 'Select {{dictionary.commonTerms.finalCustomer}}',
  finalCustomerRequired: '{{dictionary.commonTerms.finalCustomer}} is required',
  finalCustomerResidenceCity: 'City of residence {{dictionary.commonTerms.finalCustomer}}',
  finalCustomerTags: '{{dictionary.commonTerms.finalCustomer}} Tags',
  finalCustomers: '{{dictionary.commonTerms.finalCustomerPlural}}',
  finalCustomersDescription:
    'If your organization uses {{dictionary.commonTerms.finalCustomer}} list, you can select the specific {{dictionary.commonTerms.finalCustomer}} when you create a {{dictionary.commonTerms.service}}.',
  finalDate: 'Final date',
  finalEdition: 'Enable editing after {{dictionary.commonTerms.service}} is finished',
  finish: 'Finish',
  finishByFinalCustomerService: 'Finished by {{dictionary.commonTerms.finalCustomer}}',
  finishDate: 'Finish date',
  finishSequenceStep: 'Finish step',
  finishService: 'Finished {{dictionary.commonTerms.service}}',
  finishTime: 'Finish Time',
  finishTimeRequired: 'Finish Time required',
  finished: 'Finished',
  finishedBy: 'Finished By:',
  finishedRetries: 'Finished Retries',
  finishedStep: 'finished step',
  forceLockSave: 'Force save',
  formIsRequired: 'The form is required',
  formPlaceholder: 'Select a form',
  forms: 'Forms',
  frequentResponse: 'Frequent response',
  frequentResponses: 'Frequent responses',
  friday: 'Friday',
  from: 'from',
  fromNAvailable: 'from {{n}} available',
  fromNumber: 'from number',
  fuchsiaTheme: 'Magenta',
  fullName: 'Name',
  fullView: 'Full view',
  futureReminder: 'Future reminder',
  gateways: 'Payment Gateways',
  generalConfiguration: 'General configuration',
  generalConfigurationResolutionsDescription: 'Add the main numbering data',
  generalInfo: 'General Information',
  generalOptions: 'General options',
  generate: 'Generate',
  generateAdjustmentNote: 'Generate adjustment note',
  generateAdjustmentNoteWarning: 'Once the adjustment note is generated it cannot be edited.',
  generateCreditNote: 'Generate credit note',
  generateCreditNoteWarning: 'Once the credit note is generated it cannot be edited.',
  generateInvoice: 'Generate invoice',
  generateInvoiceWarning: 'Once the invoice is generated it cannot be edited.',
  generateLinkText: 'Generate links by specific {{dictionary.profileNames.technician}}',
  generatePDFText: 'Generate PDF of attention',
  generateReport: 'Generate Report',
  generated: 'Generado',
  geolocalizationFromUbidots: 'Get location from ubidots',
  goBack: 'Go back',
  gpsTextswitch: 'Request GPS for reports',
  grayTheme: 'Gray',
  greenTheme: 'Green',
  groupName: 'Group Name',
  headquarter: '{{dictionary.commonTerms.headquarter}}',
  headquarterAddress: '{{dictionary.commonTerms.headquarter}} address',
  headquarterDefault: 'General {{dictionary.commonTerms.headquarter}}',
  headquarterDescription:
    'Select the {{dictionary.commonTerms.headquarter}} to which this {{dictionary.profileNames.operator}} belongs',
  headquarterDescriptionTechnician:
    'Select the {{dictionary.commonTerms.headquarter}} to which this {{dictionary.profileNames.technician}} belongs',
  headquarterName: '{{dictionary.commonTerms.headquarter}} name',
  headquarterPlaceholder: 'Select {{dictionary.commonTerms.headquarter}}',
  headquarters: '{{dictionary.commonTerms.headquarterPlural}}',
  healthBilling: 'Health billing',
  healthInsurance: 'Health insurance',
  healthInsuranceCode: 'Health insurance code',
  healthInsurancePlaceholder: 'Select a health insurance',
  healthInsuranceRequired: 'Health insurance is required',
  healthTypeOperation: 'Operation type',
  here: 'HERE',
  highPriority: '{{dictionary.commonTerms.highPriority}}',
  historyServiceTextSwitch: 'Allow viewing the history of {{dictionary.common Terms.service Plural}} performed',
  hour: 'Hour',
  hourRequired: 'Hour is required',
  hours: 'Hours',
  hoursavailability: 'Hours and availability',
  hoursdescription:
    'If you enable schedules for the user, you will not be able to assign services at times that are outside their schedulesof availability',
  howOften: 'How often',
  howOftenPlaceholder: 'Select how often',
  htmlEditorDescription: 'Edit in HTML',
  id: 'ID',
  idSoftware: 'Id software',
  identification: 'Identification',
  identificationAlreadyExists: 'Identification already exists',
  identificationData: 'Identification data',
  identificationPlaceholder: 'Enter identification',
  identificationRequired: 'Identification is required',
  identificationType: 'Tipo de identificación',
  identificationandScearchRequired: 'You must search',
  identificator: 'Identificator',
  identificatorPlaceholder: 'Enter identificator',
  identifier: 'Identifier',
  identityKeyTestingTitle: 'Testing identity key ',
  identityKeyTitle: 'Identity key',
  idiom: 'Idiom',
  image: 'Image',
  imageDimensionsError: 'Image dimensions must be {{width}}px by {{height}}px',
  import: 'Import',
  importCustomList: 'Import custom list',
  importCustomListText: 'Download template',
  importCustomListTextModal:
    'to fill out the information and then carry out the importation clicking on the following button.',
  importFinalCustomers: 'Import {{dictionary.commonTerms.finalCustomerPlural}}',
  importFinalCustomersResult: '{{dictionary.commonTerms.finalCustomerPlural}} import result',
  importListItems: 'Impport list items',
  inProductionTitle: 'In production',
  incidentOutsideSchedule: '{{dictionary.commonTerms.servicePlural}} outside of the schedule',
  incidentTypeCreate: 'Create {{dictionary.commonTerms.service}} Type',
  incidentTypeEdit: 'Edit {{dictionary.commonTerms.service}} Type',
  incidentTypeText:
    'Create {{dictionary.commonTerms.service}} type or edit {{dictionary.commonTerms.service}} type as needed.',
  info: 'Info',
  infoMessageWhatsapp:
    'This information will not be part of the message, it will be used to later identify in the history what type of message you sent',
  infoPatient: 'Information the {{dictionary.commonTerms.finalCustomer}}',
  infoRequired: 'This information is required',
  infoServiceStatus: 'Can modify the state of {{dictionary.commonTerms.service}}',
  infoServiceStatusFromMobile: 'allow modifying the status of web {{dictionary.commonTerms.service}}',
  infoSwitchAvailability: 'You can modify advanced availability',
  informationNotShowInMessage:
    'This information will not be visible in the message, will be used form identify {{dictionary.commonTerms.surveyPlural}} in the history view',
  initialDate: 'Initial date',
  inspectFormService:
    'With this form you can input extended info as follow-up data of your {{dictionary.commonTerms.service}}',
  integrationWhatsapp: 'Integration Whatsapp',
  interested: '{{dictionary.profileNames.interested}}',
  invalidStatusTransition: 'Transición de estado inválida',
  invoiceAlreadyHasAdjustmentNote: 'The invoice already has a  adjustment note',
  invoiceAlreadyHasCreditNote: 'The invoice already has a credit note',
  invoiceDate: 'Invoice date',
  invoiceHistory: 'History invoicing',
  invoiceNumber: 'Invoice number',
  invoicePlaceholder: 'Select a invoice',
  invoiceRelated: 'Invoices related',
  invoiceStatus: 'Invoice status',
  invoiceStatusPlaceholder: 'Select a invoice status',
  invoiceTemplate: 'Invoice template',
  invoices: 'Invoices',
  invoicingFromDate: 'Invoicing from date',
  isBillable: 'Is billable?',
  isNotAValidEmail: 'Not a valid email',
  issueDate: 'Issue date',
  itemNumberN: 'Item #{{n}}',
  itemPlaceholder: 'Select a item',
  itemToBilling: 'Item to billing',
  itemWillBeRemoved: 'This item will be removed',
  items: 'Items',
  itemsToBilling: 'Items to billing',
  keyInvalid: 'Invalid identifier',
  keyLabel: 'identifier',
  keyRequired: 'Identifier is required',
  landlinePhone: 'Landline phone',
  landlinePhoneNumberPlaceholder: 'Enter phone number',
  landlinePhonePlaceholder: 'Enter a landline phone',
  landlinePhoneRequired: 'Landline phone is required',
  language: 'Language',
  languageRequired: 'The language is required',
  languageText: 'Select a language',
  lastLocation: 'Last location',
  lastReportedLocation: 'Last reported location on',
  lastname1: 'First lastname',
  lastname1Placeholder: 'Enter first lastname',
  lastname1Required: 'First lastname is required',
  lastname2: 'Second lastname',
  lastname2Placeholder: 'Enter second lastname',
  lastname2Required: 'Second lastname is required',
  latestLocationReport: 'Latest location report',
  legal: 'Legal',
  legalName: 'Legal name',
  legalNamePlaceholder: 'Enter legal name',
  legalSize: 'Legal size',
  length: 'Length',
  lengthMaxValidation: '{{label}} must have {{max}} chars at most',
  lengthMinValidation: '{{label}} must have {{min}} chars at least',
  lessThanOrEqualValidation: '{{label}} must be less than or equal to {{max}}',
  letterSize: 'Letter size',
  lettersAndNumbersOnly: 'Only letters and numbers are allowed',
  limitCharacters: 'you exceeded the character limit',
  limitSelfScheduling: 'limit auto programming period',
  limitSelfSchedulingDescription:
    'Limit the future period enabled on the selfscheduling page when selecting {{dictionary.commonTerms.servicePlural}}',
  limitSelfschedulingToCreatedFinalCustomer:
    'Limit selfscheduling to created {{dictionary.commonTerms.finalCustomerPlural}}',
  limitToCreatedFinalCustomer:
    'Only the {{dictionary.commonTerms.finalCustomerPlural}} that has been created in the application can be use the selfscheduliong',
  link: 'Link',
  linkCreateHeadquarter: 'you can create more {{dictionary.commonTerms.headquarterPlural}}',
  linkCreateSkills: ' you can create more Skills.',
  links: 'Links',
  list: 'List',
  loading: 'Loading...',
  loadingCoords: 'Loading location',
  loadingItems: 'Loading {{itemsName}}...',
  loginAction: 'Log In',
  loginTitle: 'Log In',
  logo: 'logo',
  logoSizeXY: 'Logo (Size {{x}} by {{y}})',
  logoText:
    'Upload your logo in .PNG format to appear in the top-left corner inside the web platform. Mandatory size (Width - Height) 400 x 80.',
  logs: 'Logs',
  longitude: 'Longitude',
  lot: 'Lot',
  lotRequired: 'Lot is required',
  lowPriority: '{{dictionary.commonTerms.lowPriority}}',
  mainContact: 'Main {{dictionary.commonTerms.contact}} name',
  mainContactPlaceholder: 'Enter main {{dictionary.commonTerms.contact}} name',
  mainContactRequired: 'Main {{dictionary.commonTerms.contact}} name is required',
  mainPageInstructions: 'Main page instructions',
  mainTitle: 'Main title',
  map: 'Map',
  maxDifferenceIs1Month: 'Max difference between dates is 1 month',
  medic: 'Medic',
  medicPlural: 'Medics',
  mediumPriority: '{{dictionary.commonTerms.mediumPriority}}',
  mentionedAssignments: 'All mentioned assignments will',
  message: 'Mensaje',
  messageAttempts: 'An attempt will be made to send a message to {{n}} {{dictionary.commonTerms.finalCustomerPlural}} ',
  messageDataTerms: 'of data and the ',
  messageDeletePending: 'The rescheduling will be skipped and removed from the pending list',
  messageDeletePendingIncident: 'The rescheduling will be skipped and removed from the pending list',
  messageRequired: 'The message is mandatory.',
  messageTermsAndConditions: 'I have read and accept the ',
  messengerService: 'Messaging',
  messengerServiceDescription:
    'Send personalized messages and emails to groups or segments of Patients directly, or after compliance with some rules',
  messengerServiceWhatsapp: 'Messaging: Whatsapp',
  minDateError: 'Min date is {{minDate}}',
  minDateInvoiceError: 'The invoice date must not be earlier than today',
  minRotationTime: 'The minimum rotation time is {{n}} minutes',
  minTimeError: 'Min time is {{minTime}}',
  minutes: 'Minutes',
  mobileAppColor: 'App mobile colors',
  mobileAppDescription: 'If your entity uses the mobile application, you can configure some user options',
  mobileAppModuleDescription: 'If your entity uses the mobile application, you can configure some user options.',
  mobileAppModuleText: 'Mobile App Settings',
  mobileForm: 'Mobile Form',
  mobileFormDraftSaved: 'Saved a {{dictionary.commonTerms.service}} form draft',
  mobileFormLink: 'You can create or edit with the necesary fields.',
  mobileFormRequired: 'Please select a {{dictionary.commonTerms.service}} form',
  mobileLogo: 'Mobile Logo',
  mobileLogoText:
    'Upload your logo in .PNG format so that it appears in the menu bar of the mobile application. Mandatory size (Width - Height) 270 x 100 pixels.',
  mobilePhone: 'Mobile phone',
  mobilePhoneNumber: 'Mobile phone number',
  mobilePhonePlaceholder: 'Enter a mobile phone',
  mobilePhoneRequired: 'enter the cell phone',
  modules: 'Modules',
  monday: 'Monday',
  months: 'Months',
  moveIncident: 'Move {{dictionary.commonTerms.service}}',
  moveIncidentDescription: 'The following changes will be made to the {{dictionary.commonTerms.service}}',
  movedToPending: 'They will be moved to the pending list to ensure their rescheduling.',
  multipleDays: 'Multiple days',
  municipality: 'Municipality',
  mustAddItemsInvoice: 'You must add at least one item to the invoice',
  nAppointments: '{{n}} {{dictionary.commonTerms.servicePlural}}',
  nAttachmentFiles: '{{n}} attachment files',
  nHours: '{{n}} hours',
  nMinutes: '{{n}} minutes',
  name: 'Name',
  name1: 'First name',
  name1Placeholder: 'Enter first name',
  name1Required: 'First name is required',
  name2: 'Second name',
  name2Placeholder: 'Enter second name',
  name2Required: 'Second name is required',
  nameAccount: 'AccountName',
  nameFile: 'Name of the file',
  namePlaceholder: 'Enter name',
  nameRequired: 'Name is required',
  nameTheMessage: 'Name the message',
  nationalityCountry: 'Nationality country',
  nationalityCountryPlaceholder: 'Select nationality country',
  nationalityCountryRequired: 'Nationality country is required',
  needConfigTemplates: 'You need to configure the templates to download the file.',
  newAccounts: 'Create',
  newAdjustmentNote: 'New adjustment note',
  newAppointment: 'New {{dictionary.commonTerms.service}}',
  newBilling: 'New billing',
  newCreditNote: 'New credit note',
  newCustomReport: 'Nuevo custom report',
  newNotification: 'New notification',
  newValue: 'New value',
  next: 'Next',
  nextNumberBilling: 'Next invoice number',
  nit: 'Nit',
  no: 'No',
  noApiKeysGenerated: 'No API keys have been generated',
  noApiKeysGeneratedWhatsapp: 'A Whatsapp Key has not been generated',
  noAttachments: 'No attachment',
  noBilled: 'No billed',
  noConfigured: 'No configured',
  noDataTreatmentPolicy: 'There is no data treatment policy',
  noInfoToShow: 'There is no information to show',
  noLegalTerms: 'There are no legal terms',
  noResults: 'No results',
  noScheduleTimesAvailable:
    'The selected {{dictionary.profileNames.technician}} does not avalibale schedules, please select another.',
  noSchedulesAdded: 'No schedules have been added',
  noUploadedDigitalSignature: 'You have not yet uploaded your digital signature',
  noValue: 'No value assigned',
  notActivated: 'Not activated',
  notAvailable: 'Not available',
  notAvailanle: 'Not available',
  notDelivered: 'Not delivered',
  notImportedRecords: 'Records that were not imported',
  notPrioritary: '{{dictionary.commonTerms.notPrioritary}}',
  notStarted: 'Not started',
  notSupportedField: 'This element cannot be viewed on web format',
  note: '{{dictionary.commonTerms.note}}',
  notePlural: '{{dictionary.commonTerms.notePlural}}',
  noteTypes: 'Type de {{dictionary.commonTerms.note}}',
  noteTypesRequiredMessage: 'The note is required',
  notes: '{{dictionary.commonTerms.notePlural}}',
  notesInvoiceTemplate: 'Invoice notes',
  notesTypes: 'Types de {{dictionary.commonTerms.notePlural}}',
  notification: 'Notification',
  notificationEvent: 'Event',
  notificationEventRequired: 'Event type is required',
  notificationHour: 'Notify at a specific time',
  notificationSent: 'Notification sent',
  notificationType: 'Notification type',
  notificationTypeRequired: 'Notification type is required',
  notifications: 'Notifications',
  notifyTo: 'Notify to',
  notifyToRequired: 'Mail recipient is required',
  number: 'Number',
  numbersOnly: 'Solo se permiten números',
  obligatory: 'Obligatory',
  of: 'of',
  ok: 'Ok',
  onlyNumbersValidation: '{{label}} must have only numeric chars',
  onlyOneDay: 'One day',
  operator: '{{dictionary.profileNames.operator}}',
  optionChat: 'Chat option',
  optionChatDescription:
    'Select if this {{dictionary.commonTerms.service}} has the chat option with {{dictionary.profileNames.interested}} user',
  optional: '(Optional)',
  optionalField: 'Opcional',
  optionalMobilePhone: 'Optional mobile phone',
  optionalMobilePhonePlaceholder: 'Enter an optional mobile phone',
  options: 'Options',
  orangeTheme: 'Orange',
  origin: 'Origin',
  other: 'Other',
  otherOptions: 'Other options',
  others: 'Others',
  othersMenus: 'Others menus',
  pageFooterImage: 'Page Footer Image',
  pageHeaderImage: 'Page Header Image',
  paperType: 'Paper type',
  participants: 'Participants',
  passwordAndConfirmationsMustBeEquals: 'Password confirmation does not match.',
  passwordDigits: 'Password must contain {{n}} digits',
  passwordLabel: 'Password',
  passwordLength: 'Password must be at least {{n}} chars long',
  passwordLowercaseLetters: 'Password must contain {{n}} lowercase letters',
  passwordPlaceholder: 'Write your password',
  passwordRequiredMessage: 'Password is required',
  passwordSpecialChars: 'Password must contain {{n}} of these chars: {{acceptedChars}}',
  passwordUppercaseLetters: 'Password must contain {{n}} uppercase letters',
  patiensHistoryAppointments:
    '{{dictionary.commonTerms.finalCustomerPlural}} that requested the following {{dictionary.commonTerms.servicePlural}} types',
  patientHasOverlaps:
    'The {{dictionary.commonTerms.finalCustomer}} has a {{dictionary.commonTerms.service}} in the same time',
  patientIdConfirmed: 'Patient identification confirmed',
  patientIdRejected: 'Patient identification rejected',
  pay: 'Pay',
  paymentForm: 'Payment form',
  paymentGateways: 'Payment Gateways',
  paymentMethod: 'Payment method',
  paymentMethodRequired: 'You can select a pay option',
  paymentMethodsStepText: 'In the next step will be indicate the payment methods',
  paymentPending: 'Payment Pending',
  paymentPendingDescription: 'Your payment has been verified, this process can be take some minutos',
  paymentRejected: 'Payment Rejected',
  paymentStatus: 'Payment status',
  paymentSuccessfully: 'Payment Successfully',
  pdf: 'PDF',
  pdfConfigDescription: 'Customize partially or completely the PDF documents that are generated',
  pdfConfigText: 'PDF Configuration',
  pdfFormat: 'PDF Format',
  pdfFormatBottomBorder: 'Bottom border (cm)',
  pdfFormatCopyHTMLContent: 'Copy HTML content',
  pdfFormatLeftBorder: 'Left border (cm)',
  pdfFormatPlaceholder: 'Select a format',
  pdfFormatRightBorder: 'Right border (cm)',
  pdfFormatTopBorder: 'Top border (cm)',
  pdfFormatsCustom: 'Custom',
  pdfFormatsStandard: 'Standard',
  pdfReports: 'Reports PDF',
  pdfSetting: 'PDF Settings',
  pdfTheme: 'Theme for the PDF',
  pdfThemeDescription: 'Generate PDF for this {{dictionary.commonTerms.service}} type',
  pendingAssignments: 'Pending for assignment.',
  pendings: 'Pendings',
  pendingsBoard: 'Pending board',
  pendingsBoardDescription: 'View a dashboard with a {{dictionary.commonTerms.servicePlural}} pending list ',
  permission: 'Permissions',
  permissionDenied: 'Permission denied',
  personInCharge: 'Person in charge',
  personalName: 'Personal Name',
  personalQuestion: '3. How do you name your staff?',
  personalization: 'Personalization',
  petitionBy: 'Petition created by: ',
  petitionDate: 'Petition date created: ',
  phoneNumber: 'Phone number',
  phoneNumberPlaceholder: 'Enter phone number',
  phoneNumberRequired: 'Phone number is required',
  pin: 'PIN',
  plural: 'Plural',
  pluralPlaceholder: 'Enter Plural',
  policyNumber: 'Policy number',
  prefix: 'Prefix',
  prefixNotAvailable: 'Prefix not available',
  prefixPlaceholder: 'netux',
  prefixRequired: 'Prefix is required',
  prefixText: 'Enter a prefix or identifier',
  preview: 'Previsualizar',
  previous: 'Back',
  previousValue: 'Previous value',
  priority: '{{dictionary.commonTerms.priority}}',
  priorityPlaceholder: 'select priority',
  priorityRequired: 'Priority required',
  privateId: 'Consecutive',
  productService: 'Product/Service',
  programming: 'Programming',
  programmingDescription:
    'Schedule {{dictionary.commonTerms.service}} in advance to repeat multiple times in the future.',
  publicName: 'Public name',
  publicNameRequired: 'Public name is required',
  purchasePrice: 'Purchase price',
  purchasePriceRequired: 'Purchase price is required',
  purpleTheme: 'Purple',
  quantity: 'Quantity',
  reCaptchaError: 'Captcha error, please try again',
  realTimeAcceptation: 'Aceptation',
  realTimeCreation: 'Creation',
  realTimeStart: 'Start',
  realTimeUpdate: 'Real-time update:',
  realTimeUpdateFrequency: 'Update frequency (seconds)',
  recordWillBeRemoved: 'The record: {{recordDescription}} will be removed',
  redTheme: 'Red',
  reducedView: 'Reduced view',
  reference: 'Reference',
  referencePlaceholder: 'Enter reference',
  referenceRequired: 'Reference is required',
  regime: 'Regime',
  regimePlaceholder: 'Select a regimen',
  regimeRequired: 'Regime is required',
  registerDataText: 'You can register your information to be contacted when there is availability',
  registerDate: 'Register date',
  registerInAwaitingList: 'Register in awaiting list',
  registerInAwaitingListTitle: 'Register in awaiting list',
  rejected: 'Rejected',
  rejectedBy: 'Rejected by: ',
  rejectedDate: 'Rejected date: ',
  reload: 'Reload',
  remainingAssignments: 'Remaining assignments will be',
  remindWhen: 'Remind when',
  remindWhenRequired: 'Remind when is required',
  reminder: 'Reminder',
  remove: 'Remove',
  removeUserExist: 'It is not possible to remove the {{dictionary.commonTerms.finalCustomer}}',
  removeUserExistDescription: 'Because you have scheduled appointments',
  removed: 'Removed!',
  repeatTimes: '¿how many times will it repeat?',
  repeatTimesPlaceholder: 'Select number of times',
  report: 'Report',
  reportFieldsConfig: 'Configure Report Fields',
  reportLogo: 'Report Logo',
  reportName: 'Report name',
  reportNameRequired: 'Report name required',
  reports: 'Reports',
  reprogramCountTranslation: 'They will be rescheduled',
  reprogrammedCount: 'will be rescheduled',
  requestGPSforReports: 'request GPS for reports',
  reschedule: 'Reschedule',
  rescheduleCount: 'Will reschedule ',
  rescheduleCountTranslation: 'They will be rescheduled',
  reschedulelater: 'Reschedule later',
  reserveAnotherAppointment: 'Schedule another {{dictionary.commonTerms.service}}',
  reserveAppointment: 'Reserve {{dictionary.commonTerms.finalCustomer}}',
  residenceCity: 'Residence city',
  residenceCityRequired: 'Residence city is required',
  residenceDepartment: 'Residence department',
  residenceDepartmentPlaceholder: 'Select residence department',
  residenceDepartmentRequired: 'Residence department is required',
  resolution: 'Resolution',
  resolutionDate: 'Resolution date',
  resolutionNumber: 'Resolution number',
  resolutionPlaceholder: 'Select a resolution',
  resolutions: 'Resolutions',
  resource: 'Resource',
  resourceDescription:
    'Select {{dictionary.profileNames.technicianPlural}} who can manage this {{dictionary.profileNames.operator}}',
  resourceManagement: '{{dictionary.profileNames.technicianPlural}} Management',
  resourceName: '{{dictionary.profileNames.technician}} Name',
  resourcePlaceholder: 'Select resource',
  resources: 'Resources',
  response: 'Response',
  responsible: 'Responsible',
  retried: 'Retried',
  retry: 'Retry',
  retryAfter24Hours: 'The survey must be submitted after 24 hours without a responseW',
  return: 'Return',
  review: '{{dictionary.commonTerms.review}}',
  reviewPlural: '{{dictionary.commonTerms.reviewPlural}}',
  reviewYourAvailability: 'Review your availability, the confirmation will be sent to your email',
  ripsTemplateAdjustmentNote: ' RIPS template adjustment note',
  ripsTemplateCreditNote: 'RIPs template credit note',
  ripsTemplateInvoice: 'RIPs template invoice',
  rotationTimeRequired: 'Rotation time is required',
  rowInFile: 'Row in file',
  salesBilling: 'Sales billing',
  sampleRequired: '{{sample}} is required',
  sampleSelectPlaceholder: 'Select {{sample}}',
  satisfactionSurvey: 'Satisfaction survey',
  saturday: 'Saturday',
  save: 'Save',
  saveDraft: 'Save draft',
  scheduleLock: 'Schedule lock',
  scheduleSurvey: 'Schedule Survey',
  scheduleTimeNotAvailable: 'Schedule time not available',
  scheduled: 'Scheduled',
  scheduledAppointments: 'The following {{dictionary.commonTerms.servicePlural}} are scheduled at that time:',
  scholarlyLevel: 'Scholarly level',
  scholarlyLevelPlaceholder: 'Select scholarly level',
  search: 'Search',
  searchAppointment: 'Search appointment',
  searchAssignment: 'Search assignment',
  searchChat: 'Search chat',
  searchCustomerPlaceholder: 'Enter name or identification',
  searchItem: 'Search item',
  searchNearest: 'Search nearest',
  searchRequired: 'You must do the search',
  searchSkillsPlaceholder: 'Enter skills',
  searchSpecialist: 'Search Specialist',
  secondaryEmail: 'Secondary email',
  secondaryEmailPlaceholder: 'Enter secondary email address',
  secretKeyTestingTitle: 'Testing secret Key',
  secretKeyTitle: 'Secret Key',
  seeAllServices: 'Allows viewing all types of {{dictionary.commonTerms.servicePlural}}',
  seeLocation: 'See location',
  selectAppointmentDate: 'Select a day for the appointment',
  selectAppointmentTime: 'Select time',
  selectAppointmentsTimes: 'Select times for the appointment',
  selectAsset: 'Select {{dictionary.commonTerms.asset}}',
  selectAssetType: 'Select type of {{dictionary.commonTerms.asset}}',
  selectAtLeastOneDay: 'Must select at least one day',
  selectCancellationReasson: 'Select the reason for canceling the appointment',
  selectColorForExportableFormat: 'Select a color to be used in the exportable format',
  selectCompanies: 'Select {{dictionary.commonTerms.customerPlural}}',
  selectDocument: 'Select document',
  selectEpsPlaceHolder: 'Select eps',
  selectExtension: 'Select extension',
  selectFieldType: 'Select field type',
  selectFieldsToDisplay: 'Select the fields you want to display in the reports',
  selectFile: 'Select file',
  selectForm: 'Select the form to be completed.',
  selectFormat: 'Select format',
  selectFrequentResponse: 'Select Frequent Response',
  selectHeadquarter:
    'Select the {{dictionary.commonTerms.headquarterPlural}} that apply to this type of {{dictionary.commonTerms.service}}. Also,',
  selectLocalization: 'Select localization',
  selectMessageSendingStart: 'Select the time when the messages will start being sent',
  selectNewStatus: 'Select the new status for this {{dictionary.commonTerms.service}}',
  selectOption: 'Select an option',
  selectPatienText:
    'Select the specific fields of the {{dictionary.commonTerms.finalCustomer}} that the customer must complete when self-scheduling',
  selectPaymentProviders: 'Select payment methods: ',
  selectPreferredAction: 'Select the preferred action to apply',
  selectSequence: 'Select a sequence',
  selectSkills:
    'Select the {{dictionary.commonTerms.skillsPlural}} that apply to this type of {{dictionary.commonTerms.service}}. Also',
  selectSkillsBrief: 'Select the {{dictionary.commonTerms.skillsPlural}}',
  selectSkillsCanSeeReports: 'Select the {{dictionary.commonTerms.skillsPlural}} that will have access to this report',
  selectSolution: 'Select a Solution type',
  selectStatus: 'Select a Status',
  selectSurvey: 'Select a survey',
  selectSurveyToSend: 'Seleccione Encuesta a enviar',
  selectTechnicianAndDate:
    'Select a  {{dictionary.profileNames.technician}} and a date to seek the possibility of reassignment:',
  selectTemplate: 'Select a Template',
  selectTheAppointment: 'Select the {{dictionary.commonTerms.service}}',
  selectTheTimeToSendMessage: 'Select the time at which messages will start being sent',
  selectTypeUserPlaceholder: 'Select the type of user',
  selectWebForm: 'Select a Form',
  selectWhoYou: 'Select who you will send your message to',
  selectedContact: 'Contact',
  selectedFinalCustomer: '{{dictionary.commonTerms.finalCustomer}}',
  selfScheduled: 'selfScheduled',
  selfScheduling: 'Self-Scedhuling',
  selfSchedulingAccessLink: 'Self-Scedhuling Access Link',
  selfSchedulingInstructions: 'Instructions for this type of {{dictionary.commonTerms.service}}',
  selfSchedulingLengthInstructions:
    'Define how long will it last, keep on mind that this time will determine the time to show on the self-scheduling page',
  selfSchedulingPublicNameInstructions: 'This is the name that the users will see in the self-scheduling page',
  send: 'Send',
  sendEmail: 'Send Email',
  sendTestSet: 'Send test set',
  sendThen: 'Send after of',
  sent: 'Sent',
  sentBy: 'Sent by',
  sentCreditNote: 'Sent credit note',
  sentInvoice: 'Sent invoice',
  sentMessages: 'Sent messages',
  sequence: 'Sequence',
  sequenceWillBeRemoved: 'The sequence will be Removed',
  sequences: 'Sequences',
  servedBy: 'Atendido por',
  service: '{{dictionary.commonTerms.service}}',
  serviceAssigned: '{{dictionary.commonTerms.service}} assigned',
  serviceAssignment: 'Assignment of {{dictionary.commonTerms.servicePlural}}',
  serviceBilling: 'Billing {{dictionary.commonTerms.service}}',
  serviceCanceled: '{{dictionary.commonTerms.service}} canceled',
  serviceConfirmation: '{{dictionary.commonTerms.service}} Confirmation',
  serviceConfirmationChatNoReschedule: '{{dictionary.commonTerms.service}} Confirmation (Chat - No reschedule)',
  serviceDate: 'Date',
  serviceDatePlaceholder: 'Enter a date',
  serviceDateRequired: 'Date is required',
  serviceDescription: 'Description',
  serviceDescriptionPlaceholder: 'Enter description',
  serviceDescriptionRequired: 'Description is required',
  serviceId: 'ID',
  serviceModified: '{{dictionary.commonTerms.service}} modified',
  serviceName: '{{dictionary.commonTerms.service}} name',
  serviceNamePlaceholder: 'Enter {{dictionary.commonTerms.service}} name',
  serviceNameRequired: '{{dictionary.commonTerms.service}} name is required',
  serviceSpeciality: '{{dictionary.commonTerms.skillsPlural}} of {{dictionary.commonTerms.service}}',
  serviceStatus: '{{dictionary.commonTerms.service}} status',
  serviceTags: 'Tags',
  serviceTime: 'Time',
  serviceTimePlaceholder: 'Enter a time',
  serviceTimeRequired: 'Time is required',
  serviceType: '{{dictionary.commonTerms.service}} type',
  serviceTypeNotAssignedToHeadquarter:
    'The {{dictionary.commonTerms.service}} type is not assigned to the {{dictionary.commonTerms.headquarter}}',
  serviceTypeNotAssignedToX: 'The {{dictionary.commonTerms.service}} type is not assigned to {{x}}',
  serviceTypePlaceholder: 'Select a {{dictionary.commonTerms.service}} type',
  serviceTypeRequired: '{{dictionary.commonTerms.service}} type is required',
  serviceTypeText: 'New {{dictionary.commonTerms.service}} type',
  serviceTypes: '{{dictionary.commonTerms.servicePlural}} type',
  serviceWillBeCanceled: '{{dictionary.commonTerms.service}} will be Canceled',
  serviceWillBeFinished: '{{dictionary.commonTerms.service}} will be finished',
  services: '{{dictionary.commonTerms.servicePlural}}',
  servicesByType: '{{dictionary.commonTerms.servicePlural}} by type',
  servicesCanceled: '{{dictionary.commonTerms.servicePlural}} canceled',
  servicesConfirmed: '{{dictionary.commonTerms.servicePlural}} confirmed',
  servicesCreated: '{{dictionary.commonTerms.servicePlural}} created',
  servicesFromAtoB: '{{dictionary.commonTerms.servicePlural}} from {{a}} to {{b}}',
  servicesHistory: '{{dictionary.commonTerms.servicePlural}} history',
  servicesLanding: '{{dictionary.commonTerms.servicePlural}} landing page',
  servicesPerDay: '{{dictionary.commonTerms.servicePlural}} per day',
  servicesSelfScheduled: '{{dictionary.commonTerms.servicePlural}} self-scheduled',
  servicesTypesAssigned: 'Select the types of {{dictionary.commonTerms.servicePlural}} with permission to view',
  setTestId: 'Id of the test set',
  shippingDate: 'Shipping date',
  shortDescription: 'Descripción corta',
  showLocation: 'Show location',
  signDocumentDescription: 'Use your mouse or your hand to draw your signature in this space:',
  signOut: 'Sign out',
  signature: 'Signature',
  signatureCity: 'City where signed',
  signatureDate: 'Date where signed the consent',
  signatureDay: 'Day where signed the consent',
  signatureDocument:
    'Its necessary to sign a document before accessing the {{dictionary.commonTerms.videoConsultation}} room?',
  signatureHour: 'Hour where signed the consent',
  signatureMonth: 'Month where signed the consent',
  signatureYear: 'Year where signed the consent',
  signedDocument: 'Signed document',
  singular: 'Singular',
  singularPlaceholder: 'Enter singular',
  skillPlaceholder: 'Select the skills',
  skillWillBeRemoved: 'This record will be completely removed.',
  skills: '{{dictionary.commonTerms.skills}}',
  skillsDescription:
    'Select Skills for this Resource. You can also create more Skills and associate them to the types ofService',
  skillsDescriptionFinish: 'and associate them with {{dictionary.commonTerms.service}} types',
  skillsDescriptionLink: 'You can also create more {{dictionary.commonTerms.skillsPlural}}',
  skillsForCustomPdf: '{{dictionary.commonTerms.skillsPlural}} with access to this PDF',
  skillsRequired: 'Please select at least one {{dictionary.commonTerms.skills}}',
  skillsVisiblesToService: 'Assign visibles {{dictionary.commonTerms.skills}} to this menu',
  solutionRequired: 'Select a solution type is required',
  solutionType: 'Solution type',
  someFieldsHaveErrors: 'There is fields with errors',
  spanish: 'Spanish',
  specialist: 'Specialist',
  specialistPlural: 'Specialists',
  specificEmail: 'Specific email',
  startChat: 'Start',
  startConversation: 'Iniciar conversación',
  startDate: 'Start date',
  startHour: 'Start hour',
  startService: 'start {{dictionary.commonTerms.service}}',
  startTime: 'Start Time',
  startTimeRequired: 'Start time required',
  startTimeShouldBeGreater: 'Start time must be higher',
  startedStep: 'started step',
  states: 'States',
  statistics: 'Statistics',
  status: 'Status',
  statusChangeNotAllowed: 'Status change not allowed',
  statusRequired: ' Status required',
  steps: 'Steps',
  stepsRequired: 'Steps are required',
  stock: 'Stock',
  stockAlert: 'Alert stock',
  stockDetail: 'Stock Detail',
  stocks: 'Stocks',
  subTotal: 'Subtotal',
  subject: 'Subject',
  subjectRequired: 'Subject is required',
  succesSendMessages: 'Message created successfully',
  success: 'Success',
  successCancelingService: '{{dictionary.commonTerms.service}} canceled successfully',
  successCreateToken: 'Token generate successfully',
  successCreatingCancellation: 'Cancellation created successfully',
  successCreatingRecord: 'Record created successfully',
  successDeleteSkill: 'Record successfully deleted',
  successFinishingService: '{{dictionary.commonTerms.service}} finished successfully',
  successRemoveService: '{{dictionary.commonTerms.service}} deleted successfully',
  successRemovingRecord: 'Record removed successfully',
  successStartingService: '{{dictionary.commonTerms.service}} is now in process',
  successUpdatingRecord: 'Record updated successfully',
  successUploadingFile: 'File uploaded successfully',
  successValidateFile: 'Validation file is ready for review',
  summary: '{{dictionary.commonTerms.summary}}',
  sunday: 'Sunday',
  supportChat: 'Support Chat',
  supportChatDescription:
    'Enable the support chat so that {{dictionary.commonTerms.finalCustomerPlural}} can communicate with the support team',
  surveyHistory: 'Survey history',
  surveyInfoNotPartOfMessage:
    'This information will not be visible in the message, it will used to identify Survey in the history',
  surveyIsRequired: 'Survey is required',
  surveys: 'Surveys',
  surveysDescription: 'Send surveys to your {{dictionary.commonTerms.finalCustomerPlural}} via Whatsapp',
  surveysGroup: 'Surveys Group',
  synchronizedBy: 'Synchronized By: ',
  synchronizedData: 'Partially synchronized information',
  synchronizedDate: 'Synchronized Date: ',
  synchronizedService: '{{dictionary.commonTerms.service}} synchronized',
  tagsPlaceholder: 'Enter tags to {{dictionary.commonTerms.finalCustomer}}',
  task: 'Tasks',
  tax: 'Tax',
  taxObligation: 'Tax obligation',
  technicalKey: 'Technical key',
  technician: '{{dictionary.profileNames.technician}}',
  technicianPlaceholder: 'Select {{dictionary.profileNames.technician}}',
  technicianPlural: '{{dictionary.profileNames.technicianPlural}}',
  technicianRequired: '{{dictionary.profileNames.technician}} is required',
  technicianScheduleOverlaps: '{{dictionary.profileNames.technician}} has assignations on this scheduled time',
  techniciansNear: '{{dictionary.profileNames.technician}} near',
  techniciansTracking: 'Tracking of{{dictionary.profileNames.technicianPlural}}',
  techniciansTrackingDescription:
    'Visualize the location of {{dictionary.profileNames.technicianPlural}} and the geolocation of key points',
  template: 'Template',
  templateRequired: 'Template is required',
  terms: 'Terms',
  termsAndConditionsMessage: 'terms and conditions',
  termsAndConditionsTitle: 'Terms and conditions',
  testSetApprovedDian: 'The test set has already been approved by the DIAN',
  textAccountuser:
    'To log into your account, you can use your username {{prefix}}.{{username}} and the password you entered',
  textCopyToClipBoard: 'Text has been copied to clipboard',
  textField: 'Text field',
  textGenerate: 'a new apiKey has been generated',
  the: 'the',
  theFollowingAppointments: 'The following assignments are scheduled at that time:',
  theFollowingAppointmentsCalendar: 'In this schedule the following assignments were found:',
  thereAreActiveAndUnassignedChats: 'There are active and unassigned chats',
  thereAreActiveChats: 'There are active chats',
  thereAreNoOtherOptionsEnabled: 'There are no other options enabled for this account',
  thereAreServicesAssignedWarning: 'There are {{dictionary.commonTerms.servicePlural}} assigned on this schedule',
  thereAreUnassignedChats: 'There are unassigned chats',
  thereIsNewMessages: 'There is new messages',
  thereIsNoReviewInfo: 'There is no review info',
  thisActionCannotBeUndone: 'This action cannt be undone',
  thisFieldIsRequired: 'This field is required',
  thisRecordWillBeRemoved: 'This record will be removed',
  thursday: 'Thursday',
  time: 'Time',
  timeExecution: 'Approximate execution time in minutes',
  timeFormat: 'Time format',
  timeUnit: 'Time unit',
  timeUnitPlaceholder: 'Days, weeks, months, years',
  timeUnitPlaceholderPleace: 'Select unit of time',
  timeUnitRequired: 'Time unit is required',
  timeZone: 'Time zone',
  timeZoneExample: '(UTC-05:00) Bogota, Lima, Quito',
  timeZoneText: 'Select your time zone',
  timezoneRequired: 'The time zone is required',
  titleCardselfScheduling: 'Selfscheduling page',
  titleErrorNotification: 'Unable to create this notification ',
  tittleIntegrationwhatsapp: 'Whatsapp integration',
  to: 'to',
  tokenMetaMessage: 'Enter the permanent token generated by Meta',
  topic: '{{dictionary.commonTerms.topic}}',
  topicPlural: '{{dictionary.commonTerms.topicPlural}}',
  total: 'Total',
  totalItems: 'Total items',
  totalPrice: 'Total price',
  tradeName: 'Trade name',
  tuesday: 'Tuesday',
  typeCoverageServicePlan: 'Type of coverage or service plan',
  typeOfExam: 'Type of exam',
  typeUserHealthSector: 'Type of user health sector',
  typeUsertext: 'Select the type of user, enter basic information and assign the password',
  unconfirmedAppointment: 'Not confirmed',
  unfilledFields: 'unfilled fields',
  unfilledText: 'You have not selected required fields for the creation of this {{dictionary.commonTerms.service}}',
  unit: 'Unit',
  unitValue: 'Unit value',
  until: 'Until',
  upToNumber: 'Up to the number',
  updateList: 'Edit list',
  updateListNode: 'Update node',
  updatePasswordText: 'Change password',
  updated: 'Updated',
  updatedBy: 'Updated by: ',
  updatedDate: 'Updated date: ',
  updatedFields: 'Updated fields',
  updatedMobileFormDate: 'Mobile form updated date: ',
  updatedMobileFormdBy: 'Mobile form updated by: ',
  updatedRecords: 'Records updated',
  updatedReviewForm: '{{dictionary.commonTerms.review}} form modified',
  upload: 'Upload',
  uploadDigitalCertificate: 'Upload digital certificate',
  uploadDigitalSignature: 'Upload digital signature',
  uploadImportsTemplateMessage: 'Upload template completed',
  uploadTemplate: 'Upload template',
  urlFinalCustomerRoom: 'URL {{dictionary.commonTerms.finalCustomer}} room',
  urlResourcesRoom: 'URL {{dictionary.profileNames.technician}} room',
  urlVideoConsultation: 'URL {{dictionary.commonTerms.videoConsultation}} room',
  user: 'User',
  userAdmin: 'admin user',
  userAdminPlaceholder: 'admin',
  userAdminRequired: 'admin user is required',
  userCannotPerformService:
    'The {{dictionary.profileNames.technician}} cannot perform this type of {{dictionary.commonTerms.service}}',
  userDevices: 'User devices',
  userDevicesLogs: 'User devices logs',
  userHasOverlaps:
    'The {{dictionary.profileNames.technician}} has a {{dictionary.commonTerms.service}} at the same time',
  userNotAssignedToHeadquarter:
    'The {{dictionary.profileNames.technician}} is not assigned to the selected {{dictionary.commonTerms.headquarter}}',
  userNotAssignedToX: 'The {{dictionary.profileNames.technician}} is not assigned to {{x}}',
  userNotAvailable: 'The {{dictionary.profileNames.technician}} is not available at the selected time',
  userType: 'User Type',
  userTypeConfigBase: 'User type and base configuration',
  userTypeDescriptiontitle: 'Have in point that',
  userTypeInterestedDescription:
    ' The user {{dictionary.profileNames.interested}}  uses the web platform and can only view reports ',
  userTypeOperatorDescription:
    'The {{dictionary.profileNames.operator}} user uses the web platform and focuses on appointment scheduling and tracking',
  userTypeRequired: 'userType is required',
  userTypeTechnicianDescription:
    'The user {{dictionary.profileNames.technician}} uses the mobile app and does field tasks',
  userWillBeDisabled: 'The user will be disabled and will not be able to access the platform',
  username: 'username',
  usernameAlreadyExists: 'username already exists',
  usernameDescription: 'the user must use {{username}} to login into the app ',
  usernameLabel: 'Username or email',
  usernamePlaceholder: 'Write your username or email',
  usernameRequired: 'You must enter an username ',
  usernameRequiredMessage: 'You must enter an username or email',
  users: 'Users',
  validationErrorTitle: 'Validation errors',
  validationRemindWhen: 'Number cant be lower or equal to 0',
  validityFrom: 'Validity from',
  validityUntil: 'Validity until',
  value: 'Value',
  valueLabel: 'value',
  valuePlaceholder: 'Enter value',
  valueRequired: 'value is required',
  valueToPay: 'Value to pay: ',
  values: 'Values',
  variables: 'Variables',
  variablesDescription: 'Enable this kind of attention',
  verificationDocumentText: 'Cannot save this information',
  verifyAssignations: 'Verify assignations',
  video: 'video',
  videoConsultationConfiguration: '{{dictionary.commonTerms.videoConsultation}} settings',
  videoConsultationEnable: '{{dictionary.commonTerms.videoConsultation}} option',
  videoConsultationEnableDescription:
    'With this option, when create this type of {{dictionary.commonTerms.service}} can be done through {{dictionary.commonTerms.videoConsultation}}',
  videoconsultationAssignation:
    '{{dictionary.commonTerms.service}} assignment {{dictionary.commonTerms.videoConsultation}}',
  videoconsultationConfirmation:
    '{{dictionary.commonTerms.service}} Confirmation ({{dictionary.commonTerms.videoConsultation}})',
  videoconsultationRoom: '{{dictionary.commonTerms.videoConsultation}} room',
  videoconsultationRoomDescription: 'Enable {{dictionary.commonTerms.videoConsultation}} room',
  viewAccounts: 'View accounts',
  viewAllCustomers: 'View all {{dictionary.commonTerms.customerPlural}}',
  viewContainer: 'View container',
  viewCustomers: 'View {{dictionary.commonTerms.customerPlural}}',
  viewCustomersText:
    'The user will be able to see the list of {{dictionary.commonTerms.customerPlural}} and select one according to their preference. Select NO only if you dont have any {{dictionary.commonTerms.customer}} created',
  viewDetails: 'View details',
  viewMore: 'View more',
  viewServicesCustomers: 'View {{dictionary.commonTerms.servicePlural}} {{dictionary.commonTerms.customerPlural}}',
  viewServicesCustomersDescription: 'View information about all {{dictionary.commonTerms.customerPlural}}',
  viewUpdatedFields: 'Ver campos actualizados',
  viewUsers: 'View {{dictionary.profileNames.technicianPlural}}',
  viewUsersText:
    'The User can view the list of {{dictionary.profileNames.technicianPlural}} and choose as per his your preference. If your choose "No" option, the user cant see the list of {{dictionary.profileNames.technicianPlural}}, so a random and available {{dictionary.profileNames.technicianPlural}} is assigned.',
  viewedBy: 'Read by',
  viewwingModeText:
    'Your account is in viewing mode, you will not be able to create {{dictionary.commonTerms.servicePlural}}. Please contact an advisor to activate itagain',
  waitForFinalCustomer: 'En espera de {{dictionary.commonTerms.finalCustomerPlural}}',
  waitForFinalCustomerResponse: 'waiting for {{dictionary.commonTerms.finalCustomer}} response',
  waitingForResponse: 'Waiting for response',
  warnServiceWithoutFinalCustomerToInvoice:
    'You cannot bill this {{dictionary.commonTerms.service}} because it does not have an associated {{dictionary.commonTerms.finalCustomer}}.',
  warning: 'Warning',
  webhookMessage: 'In Meta you also need to enter the webhook. Remember that it is the following:',
  wednesday: 'Wednesday',
  week: 'Week',
  weeks: 'Weeks',
  welcomeText: 'Welcome! Fill out the following information to create your account',
  whatsapp: 'Whatsapp',
  whatsappScheulding: 'Allow scheduling by Whatsapp',
  whoSignDocument: 'Who signs the document?',
  widgetsExternal: 'Widgets external',
  willBeAssigned: 'Will assign ',
  willLoseConditionalValues:
    'Changing the selection will result in losing the conditional values linked to the current option. Do you wish to proceed?',
  wppNumberHasActiveChats: 'This phone númber has active chats',
  writeAMessage: 'Write a message',
  wrongValue: 'Wrong value',
  xNotAssignedToY: '{{x}} is not assigned to {{y}}',
  years: 'Years',
  yes: 'Yes',
  you: 'You',
  yourAppointmentWillBeConfirmed: 'Your appointment will be confirmed',
  zipNumberN: 'Zip #{{n}}',
  zipsList: 'Zips list',
};
